export default function $(elem_id) {
  if (
    (typeof elem_id === "string" && elem_id.charAt(0) === ".") ||
    elem_id.charAt(0) === "#" ||
    elem_id === "head" ||
    elem_id === "body"
  ) {
    if (document.querySelector(elem_id)) {
      return document.querySelector(elem_id);
    } else {
      console.error(`${elem_id} does not exist!`);
    }
  } else {
    console.error("err");
    console.log(
      `%c` +
        elem_id +
        "%c%c❗️Identifier must be type of string and must also include at . or # at the begining of the string",
      " border: 0.5px solid #000000; background: #2c2c30; color: #c1c6da; border-radius: 10px; font-weight:bold; padding: 10px; margin-top: 10px; margin-bottom: 10px",
      "font-weight: bold",
      "color: #fff; background: #6b3939; padding: 4px 8px; border-radius: 4px; margin-bottom: 10px;",
    );
  }
}
